import type { PartnerConfig } from "@/content/partners/types"

export const MONKEYS_FEST_RIDE_2026_SLUG = "monkeys-fest-ride-2026"

export const MONKEYS_FEST_RIDE_2026_EVENT_URL = "https://raceresult.com.br/e/RR-2026-1229"

/** Fim do dia 11/10/2026 America/Sao_Paulo (UTC−3). */
export const MONKEYS_FEST_RIDE_2026_ACTIVE_UNTIL = "2026-10-12T02:59:59.999Z"

export const monkeysFestRide2026PartnerConfig: PartnerConfig = {
  slug: MONKEYS_FEST_RIDE_2026_SLUG,
  name: "Monkeys Fest Ride",
  fullName: "Monkeys Fest Ride 2026",
  logoPath: "/partners/monkeys-fest-ride-2026/logo.jpg",
  benefitMode: "none",
  isActive: true,
  activeUntil: MONKEYS_FEST_RIDE_2026_ACTIVE_UNTIL,
  partnershipMention: "Parceria de evento · Monkeys Fest Ride 2026",
  metadata: {
    kind: "event_partnership_coupon",
    website: MONKEYS_FEST_RIDE_2026_EVENT_URL,
    event_platform: "race_result",
    coupon_amount_brl: 100,
  },
}

export const monkeysFestRide2026LpContent = {
  slug: MONKEYS_FEST_RIDE_2026_SLUG,
  eventName: "Monkeys Fest Ride 2026",
  logoPath: monkeysFestRide2026PartnerConfig.logoPath,
  datesLabel: "9 a 11 de outubro de 2026",
  locationLabel: "Macacos/MG",
  platformName: "Race Result",
  eventUrl: MONKEYS_FEST_RIDE_2026_EVENT_URL,
  heroKicker: "Parceria Monkeys Fest Ride 2026",
  heroSubtitle:
    "Energia solar por assinatura, sem obra e sem investimento inicial. Quem concluir a adesão por este link recebe um cupom de R$ 100 na inscrição.",
  partnershipTitle: "R$ 100 na inscrição",
  partnershipIntro:
    "Depois que você concluir a adesão por este link, enviamos o cupom para você usar na inscrição no Race Result.",
  benefitHeadline: "O que esta parceria inclui",
  benefits: [
    {
      title: "Cupom de R$ 100 na inscrição",
      text: "Vale na inscrição do Monkeys Fest Ride 2026, no Race Result.",
    },
    {
      title: "Enviamos depois da adesão",
      text: "Você recebe o cupom depois de concluir a adesão por este link.",
    },
    {
      title: "Desconto da Astra na conta de luz",
      text: "O plano segue a regra usual da assinatura, conforme o consumo da sua conta Cemig.",
    },
  ],
  faqs: [
    {
      question: "Quem recebe o cupom de R$ 100?",
      answer:
        "Quem concluir a adesão Astra por este link, com os termos assinados e o contato confirmado.",
    },
    {
      question: "Quando eu recebo o código?",
      answer: "Depois da adesão concluída. Enviamos o cupom para você.",
    },
    {
      question: "Como uso o cupom no Race Result?",
      answer:
        "Quando receber o código, abra a inscrição do Monkeys Fest Ride 2026 no Race Result e informe o cupom no checkout do evento.",
    },
    {
      question: "Esse cupom vale em outro evento?",
      answer: "Ele vale na inscrição do Monkeys Fest Ride 2026.",
    },
    {
      question: "Isso aumenta o desconto na conta de luz?",
      answer:
        "O desconto da assinatura Astra continua o do seu plano. O R$ 100 entra na inscrição.",
    },
    {
      question: "A Astra instala painéis no meu telhado?",
      answer:
        "Não. É energia solar por assinatura: a geração vem de usinas da Astra e você recebe desconto na conta de luz, sem obra e sem investimento inicial.",
    },
  ],
  ctaLabel: "Fazer minha adesão",
  ctaFinalHeadline: "Faça sua adesão por este link",
  ctaFinalSubtitle:
    "Sem obra e sem investimento inicial. Depois da adesão concluída, enviamos o cupom de R$ 100 da inscrição.",
  disclaimer:
    "Cupom de R$ 100 na inscrição do Monkeys Fest Ride 2026, no Race Result. Enviamos o código depois da adesão concluída por este link.",
  metaTitle: "Monkeys Fest Ride 2026 · R$ 100 na inscrição | Astra Energia",
  metaDescription:
    "Faça sua adesão à Astra Energia pelo link do Monkeys Fest Ride 2026 e receba um cupom de R$ 100 na inscrição no Race Result. Sem obra e sem investimento inicial.",
} as const
